import React, { useState, useEffect, useCallback } from "react";
import Container from "react-bootstrap/Container";
import Jumbotron from "react-bootstrap/Jumbotron";
import Row from "react-bootstrap/Row";
import ProjectCard from "./ProjectCard";
import axios from "axios";

const Projects = ({ heading, username, repos }) => {
    const url = `https://api.github.com/users/${username}/repos`;

	const [projectsArray, setProjectsArray] = useState([]);

	const fetchRepos = useCallback(async () => {
		let repoList = [];
		try {
			const allRepos = await axios.get(url);

            for (let name of repos) {
                const repo = allRepos.data.find(repo => repo.name === name);
                repoList.push(repo);
            }

			setProjectsArray(repoList);
		} catch (error) {
			console.error(error.message);
		}
	}, [url, repos]);

	useEffect(() => {
		fetchRepos();
	}, [fetchRepos]);

	return (
		<Jumbotron fluid id="projects" className="bg-light m-0">
			<Container className="">
				<h2 className="display-4 pb-5 text-center">{heading}</h2>
				<Row>
					{projectsArray.map((project, index) => (
						<ProjectCard key={`project-card-${index}`} id={`project-card-${index}`} value={project}/>
					))}
				</Row>
			</Container>
		</Jumbotron>
	);
};

export default Projects;